import Vue from 'www/vue_components'
import vuetify from 'www/modules/vuetify-plugin-without-reset-scss'
import CoreSmartCaptcha from 'src/core/CoreSmartCaptcha/CoreSmartCaptcha.vue'

const mountElement = document.querySelector('.vue-core-smart-captcha-mount')

if (mountElement) {
  new Vue({
    vuetify,
    el: mountElement,
    components: {
      CoreSmartCaptcha,
    },
  })
}
